import { ColDef } from 'ag-grid-enterprise';

import { FilterCriteria } from './composer-grid.models';

export function mapFilterModel(filterModel: Record<string, any> | undefined, columnDefs: ColDef[]): FilterCriteria[] {
  if (!filterModel) return [];

  const filters: FilterCriteria[] = [];
  for (const [field, model] of Object.entries(filterModel)) {
    if (model.filterType === 'set') {
      const selectedValues: string[] = model.values || [];
      const colDef = columnDefs.find((c) => c.field === field);
      const rawMap: Record<string, string> = colDef?.filterParams?.displayToRawMap;

      for (const displayVal of selectedValues) {
        const rawVal = rawMap ? rawMap[displayVal] : displayVal;
        filters.push({ field, operation: 'equals', value: rawVal });
      }
    } else if (model.condition1 && model.condition2) {
      filters.push({ field, operation: model.condition1.type, value: model.condition1.filter });
      filters.push({ field, operation: model.condition2.type, value: model.condition2.filter });
    } else {
      filters.push({ field, operation: model.type, value: model.filter });
    }
  }
  return filters;
}
